export const maskEmail = (email) => {
  if (!email) return "";
  const [name, domain] = email.split("@");
  if (!domain) return email;

  return `${name.slice(0, 2)}***@${domain}`;
};

export const maskMobile = (mobile) => {
  if (!mobile) return "";
  return `******${mobile.slice(-4)}`;
};
